import { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { API_PATCH, DBRequest, useConfig } from '../api/api';

const UserPreferencesContext = createContext({
  preferences: null,
  updatePreferences: () => {},
});

export const UserPreferencesProvider = ({ children }) => {
  const config = useConfig();
  const [preferences, setPreferences] = useState(null);

  useEffect(() => {
    // Public pages (invites, customer-data-form, ...) have no session —
    // skip the authenticated request instead of provoking 401s.
    if (!new Cookies().get('accessToken')) return;
    DBRequest({
      config,
      path: `userpreferences/own`,
      onResponse: (res) => {
        setPreferences(res.data?.additionalOptions || {});
      },
    });
  }, [config]);

  const updatePreferences = (key, value, deconstruct) => {
    const newAdditionalOptions = deconstruct
      ? { ...preferences, ...value }
      : {
          ...preferences,
          [key]: value,
        };

    DBRequest({
      config,
      path: `userpreferences/own`,
      method: API_PATCH({ additionalOptions: newAdditionalOptions }),
      onResponse: (res) => {
        setPreferences(res.data?.additionalOptions || {});
      },
    });
  };

  return (
    <UserPreferencesContext.Provider value={{ preferences, updatePreferences }}>
      {children}
    </UserPreferencesContext.Provider>
  );
};

export const useUserPreferences = () => useContext(UserPreferencesContext);
